import React from 'react';
import PropTypes from 'prop-types';
import {Message} from '../../';

const NotReady = ({supportUrl, supportName}) => {
    return (
        <div>
            <Message
                as="p"
                code="errors.com.epicgames.ecommerce.payout.esports.participation_form.not_ready"
                args={[supportUrl, supportName]}
            />
        </div>
    );
};

NotReady.displayName = 'NotReady';

NotReady.propTypes = {
    supportUrl: PropTypes.string,
    supportName: PropTypes.string
};

export default NotReady;
